import { createContext, useState, useEffect } from 'react';
import axios from 'utils/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const token = window.localStorage.getItem('gpo_token');
        if (token) {
          const response = await axios.get('/v1/merchant');
          setUser(response.data);
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      } catch (err) {
        setIsLoggedIn(false);
      } finally {
        setIsInitialized(true);
      }
    };

    init();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post('/v1/auth/login', { email, password });
    const { type, token, merchant } = response.data;
    
    if (type === 'admin') {
      window.localStorage.setItem('gpo_admin_token', token);
      window.localStorage.setItem(
        'gpo_admin_user',
        JSON.stringify(response.data.user || { name: 'Super Administrador', email: 'admin@kambatime.com' })
      );
      return 'admin';
    } else {
      window.localStorage.setItem('gpo_token', token);
      setUser(merchant);
      setIsLoggedIn(true);
      return 'merchant';
    }
  };

  const register = async (data) => {
    const response = await axios.post('/v1/merchants/register', data);
    return response.data;
  };

  const logout = async () => {
    try {
      await axios.post('/v1/auth/logout');
    } catch(e) {}
    window.localStorage.removeItem('gpo_token');
    // O modo (Produção/Sandbox) é por sessão: o próximo login usa o padrão da conta
    window.localStorage.removeItem('gpo_mode');
    setUser(null);
    setIsLoggedIn(false);
  };

  const refreshProfile = async () => {
    try {
      const response = await axios.get('/v1/merchant');
      setUser(response.data);
      return response.data;
    } catch (err) {
      console.error('Erro ao atualizar perfil:', err);
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, isInitialized, user, login, logout, register, setUser, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
